import { yupResolver } from '@hookform/resolvers/yup';
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { useLoadingContext } from '../../context/loadingContext';
import { FormProvider, RHFTextField } from '../../components/hook-form';
import Iconify from '../../components/Iconify';
import Page from '../../components/Page';
import { PromotionService } from '../../Services/promotion.service';
import { CKEditorComponent } from '../CKEditor';
import RHFTextArea from '../../components/hook-form/RHFTextArea';

const EventSchema = Yup.object().shape({
  title: Yup.string().required('Tiêu đề không đươc để trống'),
});

export const EditPromotion = () => {
  const navigate = useNavigate();
  const [promotion, setPromotion] = useState({});
  const { slug } = useParams();
  const [content, setContent] = useState('');
  const [image, setImage] = useState();
  const [imageReview, setImageReview] = useState();
  const [isHotPromotion, setIsHotPromotion] = useState(false);
  const [showBeforePublic, setShowBeforePublic] = useState(false);
  const [isLink, setIsLink] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [dateTime, setDateTime] = React.useState({
    fromDate: '',
    toDate: '',
  });
  const { handleStartLoading, handleStopLoading } = useLoadingContext();

  useEffect(() => {
    getPromotionBySlug().finally(handleStopLoading);
  }, []);

  const convertToLocalDateTime = (time) => {
    const temp = new Date(time);
    return `${temp.getFullYear()}-${`${temp.getMonth() + 1}`.padStart(2, 0)}-${`${temp.getDate()}`.padStart(
      2,
      0
    )}T${`${temp.getHours()}`.padStart(2, 0)}:${`${temp.getMinutes()}`.padStart(2, 0)}`;
  };

  const getPromotionBySlug = async () => {
    handleStartLoading();
    const promotionData = await PromotionService.GetPromotionBySlug(slug);
    const { promotion: promotionReturn } = promotionData;

    const tempFrom = new Date(promotionReturn.fromDateTime);
    const tempTo = new Date(promotionReturn.fromDateTime);

    const from = `${tempFrom.getFullYear()}-${`${tempFrom.getMonth() + 1}`.padStart(
      2,
      0
    )}-${`${tempFrom.getDate()}`.padStart(2, 0)}T${`${tempFrom.getHours()}`.padStart(
      2,
      0
    )}:${`${tempFrom.getMinutes()}`.padStart(2, 0)}`;

    const to = `${tempTo.getFullYear()}-${`${tempTo.getMonth() + 1}`.padStart(2, 0)}-${`${tempTo.getDate()}`.padStart(
      2,
      0
    )}T${`${tempTo.getHours()}`.padStart(2, 0)}:${`${tempTo.getMinutes()}`.padStart(2, 0)}`;
    setValue('title', promotionReturn.title);
    setIsHotPromotion(promotionReturn.isHotPromotion);
    setIsLink(promotionReturn.isLink);
    setShowBeforePublic(promotionReturn.showBeforePublic);
    setPromotion(promotionReturn);
    setContent(promotionReturn.content);
    setDateTime({
      fromDate: convertToLocalDateTime(promotionReturn.fromDateTime),
      // fromDate: moment(promotionReturn.fromDateTime).format('YYYY-MM-DDTkk:mm'),
      // toDate: moment(promotionReturn.toDateTime).format('YYYY-MM-DDTkk:mm'),
      toDate: convertToLocalDateTime(promotionReturn.toDateTime),
    });
    setValue('promoCode', promotionReturn.promoCode);
    setValue('notes', promotionReturn.notes);

    setImageReview(`${process.env.REACT_APP_IMAGE}${promotionReturn.logo}`);
  };

  /** React hook form --------------------------------- */
  const defaultValues = {
    title: '',
    promoCode: '',
  };

  const methods = useForm({
    resolver: yupResolver(EventSchema),
    defaultValues,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDateTime((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const {
    handleSubmit,
    formState: { isSubmitting },
    setValue,
  } = methods;
  /** -------------------------------------------------- */

  const handleOnSubmit = (data) => {
    const form = new FormData();
    if (!content || content.length === 0) {
      enqueueSnackbar('Nội dung không được để trống', { variant: 'error' });
      return;
    }
    form.append('title', data.title);
    form.append('content', content);
    form.append('logo', image);
    form.append('fromDateTime', dateTime.fromDate);
    form.append('showBeforePublic', showBeforePublic);
    form.append('isHotPromotion', isHotPromotion);
    form.append('toDateTime', dateTime.toDate);
    form.append('promoCode', data.promoCode);
    form.append('notes', data.notes);
    form.append('isLink', isLink ?? false);
    handleStartLoading();
    PromotionService.EditPromotion(promotion._id, form)
      .then((res) => {
        navigate(`/promotion/view/${res.slug}`, { replace: true, state: '/promotion' });
        enqueueSnackbar('Thêm sự khuyến mại thành công', { variant: 'success' });
      })
      .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
      .finally(handleStopLoading);
  };

  const handleCancelClick = () => {
    navigate(-1);
  };

  const handleAvatarChange = (e) => {
    const img = e.target.files[0];
    const review = URL.createObjectURL(img);
    setImageReview(review);
    setImage(img);
  };

  return (
    <Page title="Create event">
      <FormProvider methods={methods} onSubmit={handleSubmit(handleOnSubmit)}>
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Thêm khuyến mãi mới
            </Typography>
            <Stack direction={'row'} spacing={1}>
              <Button
                type="button"
                onClick={handleCancelClick}
                color="error"
                variant="contained"
                startIcon={<Iconify icon="iconoir:cancel" />}
              >
                Cancel
              </Button>
              <Button disabled={isSubmitting} type="submit" variant="contained" startIcon={<Iconify icon="bx:save" />}>
                Save
              </Button>
            </Stack>
          </Stack>
          <Card>
            <CardContent>
              <Grid container spacing={3} direction={{ xs: 'column-reverse', md: 'row' }}>
                <Grid item xs={12} md={8}>
                  <Stack spacing={3}>
                    <RHFTextField name="title" label={'Tiêu đề'} />
                    <RHFTextField name="promoCode" label={'Code'} />
                    <Typography sx={{ mt: '4px !important' }} variant="caption">
                      Voucher sử dụng nhiều lần bắt đầu bằng FBxxx
                    </Typography>
                    <RHFTextArea name="notes" label={'Notes'} />
                    <TextField
                      disabled={isSubmitting}
                      name="fromDate"
                      value={dateTime?.fromDate}
                      onChange={handleChange}
                      type={'datetime-local'}
                      size="small"
                      InputLabelProps={{
                        shrink: false,
                      }}
                    />
                    <TextField
                      disabled={isSubmitting}
                      InputProps={{ inputProps: { min: dateTime?.fromDate } }}
                      type={'datetime-local'}
                      name="toDate"
                      value={dateTime?.toDate}
                      onChange={handleChange}
                      size="small"
                    />
                    <Stack direction="row" spacing={3}>
                      <FormControlLabel
                        control={
                          <Checkbox checked={isHotPromotion} onChange={(e) => setIsHotPromotion(e.target.checked)} />
                        }
                        label="Hot Promotion"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={showBeforePublic}
                            onChange={(e) => setShowBeforePublic(e.target.checked)}
                          />
                        }
                        label="Hiện thị trước khi đến thời gian"
                      />
                      <FormControlLabel
                        control={<Checkbox checked={isLink} onChange={(e) => setIsLink(e.target.checked)} />}
                        label="Chỉ dùng link"
                      />
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Button
                    disabled={isSubmitting}
                    sx={{ border: '1px dashed gray' }}
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input onChange={handleAvatarChange} hidden accept="image/*" type="file" />
                    {imageReview ? (
                      <img
                        src={imageReview}
                        alt="noimage"
                        width={'300px'}
                        height={'180px'}
                        style={{ objectFit: 'cover' }}
                      />
                    ) : (
                      <img
                        src="/static/noimage.jpeg"
                        alt="noimage"
                        width={'300px'}
                        height={'180px'}
                        style={{ objectFit: 'cover' }}
                      />
                    )}
                  </Button>
                  <Typography variant="body2" display="block" sx={{ opacity: '0.6' }}>
                    Kích thước: 520x320
                  </Typography>
                </Grid>
              </Grid>
              <CKEditorComponent
                disabled={isSubmitting}
                placeholder={'Nội dung khuyến mãi'}
                onValueChange={setContent}
                value={content}
              />
            </CardContent>
          </Card>
        </Container>
      </FormProvider>
    </Page>
  );
};
